import React from "react";
import Button from "../Button/Button";
import Modal from "../Modal/Modal";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const CloseConfirmationModal: React.FC<Props> = ({
  open,
  onClose,
  onConfirm
}) => {
  return (
    <Modal open={open} close={onClose}>
      <div className="p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Cancel Due Diligence?
        </h3>
        <p className="text-sm text-gray-600 mb-6">
          Are you sure you want to cancel? Your progress will be autosaved.
        </p>
        <div className="flex gap-3">
          <Button type="secondary" className="flex-1" onClick={onClose}>
            Cancel
          </Button>
          <Button type="negative" className="flex-1" onClick={onConfirm}>
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CloseConfirmationModal;
